import {channelRoomRateConstants} from "../../../../constants/Network/Channels/channelRoomRate.constants";

const initialState = {
    fetching : false,
    error : '',
    getChannelRoomRate: [],
    updateChannelRoomRate: [],
    updateError: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case channelRoomRateConstants.CHANNEL_ROOM_RATE_GET_PENDING:
            return {
                ...state,
                fetching: true,
                updateChannelRoomRate: [],
            };
        case channelRoomRateConstants.CHANNEL_ROOM_RATE_GET_FULFILLED:
            return {
                ...state,
                fetching: false,
                getChannelRoomRate: action.payload.data,
            };
        case channelRoomRateConstants.CHANNEL_ROOM_RATE_GET_REJECTED:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        default:
            return state
    }
}
